module.exports = __webpack_public_path__ + "img/Luis-Pereira.cf258002.jpg";